export enum BidMeetingEventTitle {
	BriefingSession = "Briefing Session",
	BSC = "BSC Meeting",
	BEC = "BEC Meeting",
	BAC = "BAC Meeting",
	BidEvaluation = "Supplier Presentations",
	BidClosingDate = "Estimated Bid Closing Date",
	BidEnquiryCutOffDate = "Bid Enquiry Cut-Off Date",
	PerformanceEvaluation = "Performance Evaluation",
	PriceReading = "Price Reading",
	CBAC = "CBAC Meeting",
	NBAC = "NBAC Meeting",
}

export enum BidMeetingEventName {
	BriefingSession = "Briefing Session",
	BSC = "BSC",
	BEC = "BEC",
	BAC = "BAC",
	BidEvaluation = "Bid Evaluation",
	BidClosingDate = "Bid Closing Date",
	BidEnquiryCutOffDate = "Enquiry Cut-Off",
	PerformanceEvaluation = "Performance Evaluation",
	PriceReading = "Price Reading",
	CBAC = "CBAC",
	NBAC = "NBAC",
}

export enum BidMeetingEventTypeId {
	BriefingSession = 1,
	BSC = 2,
	BEC = 3,
	BAC = 4,
	BidEvaluation = 5,
	BidClosingDate = 6,
	BidEnquiryCutOffDate = 7,
	PerformanceEvaluation = 8,
	PriceReading = 9,
	CBAC = 10,
	NBAC = 11,
}

export enum MeetingLocation {
	Online = 1,
	Physical = 2,
}

export enum SchedulerEventConfirmationType {
	Accept = "accept",
	Decline = "decline",
	ProposeNewTime = "propose-new-time",
}

export enum BidCommitteeTypeId {
	BSC = 1,
	BEC = 2,
	BAC = 3,
}

export enum BidMeetingStatusId {
	New = 1,
	Scheduled = 2,
	Canceled = 3,
	Rescheduled = 4,
	InProgress = 5,
	Completed = 6,
}

export enum SchedulerEventModule {
	Bid = "bid",
	Contract = "contract",
}
